import React, { useState, useEffect, useRef } from 'react';
import './Element.css';
// import { EditText, EditTextarea } from "react-edit-text";
import "react-edit-text/dist/index.css";
import { useSelector, useDispatch } from "react-redux";
import { updateGoToSlide, updateIsVoiceInput } from '../../redux/slices/userActivity';
import { useLocation, } from "react-router-dom";
import { showDuonutresponse, saveQuizAnsAsync, saveQuizResponse } from '../../redux/slices/DuonutReducer';
import { showduonutData } from '../../redux/slices/DuonutReducer';
import { getOpenEndedQuestionAsync } from '../../redux/slices/AiDuonutNewReducer';
import axios from "axios";
import { domain } from "../../services/constants";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { Tooltip as ReactTooltip } from "react-tooltip";
import 'react-tooltip/dist/react-tooltip.css';

var aiCount = 0;
var aiConversation = [];
var audioFile = null;
const Nps = ({
  id,
  elementAttr,
  elementHoverAttr,
  // conditions,
  language,
  slideId,
}) => {
  const dispatch = useDispatch();
  const { fontFamily, fontSize, fontWeight, text, fontStyle, textDecoration, textTransform, textAlign, border, color,
    lineHeight, letterSpacing, margin, padding, borderRadius, maxLength, backgroundColor, gap,
    labelFontSize, labelFontWeight, labelColor, size, required, negativeText, positiveText,
    openEnded, openEndedObjective, openEndedFeedbackDesired,
  } = elementAttr;

  const save_ans_response = useSelector(showDuonutresponse);
  const { viewer_display_id, viewer_nick_name, viewer_url_params } = useSelector((state) => state.duonut);
  // const { viewType } = useSelector((state) => state.duonutSettings);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const p_type = queryParams.get('type');
  const { width } = useWindowDimensions();
  const { viewType } = useSelector((state) => state.duonutSettings);
  const { selectedSlide, queSpeechPlaying, isVoiceInput } = useSelector((state) => state.userActivity);

  const duonutDataMain = useSelector(showduonutData);
  const duonutData = duonutDataMain[0];
  // console.log(duonutData)
  const [inputText, setInputText] = useState("");
  const [isHovered, setIsHovered] = useState(-1);
  const [clickedNum, setClickedNum] = useState(-1);
  const [textField, setTextField] = useState('');
  const [loading, setloading] = useState(false);

  const npsRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [typedText, setTypedText] = useState("");
  const [isListening, setIsListening] = useState(false)
  const [error, setError] = useState("")
  const [isTypingDone, setIsTypingDone] = useState(true);
  const recognitionRef = useRef(null)
  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);

  useEffect(() => {
    if (!inputText || !audioUrl) return;

    // Safely split words including spaces
    const words = inputText.match(/\S+\s*/g)?.filter(Boolean) || [];

    if (words.length === 0) return;

    let index = 0;
    let currentText = "";
    setIsTypingDone(false); // start typing → disable input

    const interval = setInterval(() => {
      if (index < words.length) {
        currentText += words[index]; // safe accumulation
        setTypedText(currentText);
        index++;
      } else {
        clearInterval(interval);
        setIsTypingDone(true); // ✅ Typing complete → enable input
      }
    }, 300);

    return () => clearInterval(interval);
  }, [inputText, audioUrl]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.5 } // 50% of the div must be visible
    );

    if (npsRef.current) {
      observer.observe(npsRef.current);
    }

    return () => {
      if (npsRef.current) {
        observer.unobserve(npsRef.current);
      }
    };
  }, [inputText]);

  useEffect(() => {
    setTextField("");
    if (isVisible && inputText && queSpeechPlaying && duonutData?.setting?.question_speech && location.pathname.includes("/duonut/") && slideId === `slide-${selectedSlide}`) {
      fetchAudio(inputText);
    } else {
      setAudioUrl(null);
    }
  }, [isVisible, inputText, queSpeechPlaying]);

  useEffect(() => {
    aiCount = 0;
    aiConversation = [];

    if (location.pathname.includes("/duonut/") && slideId === `slide-${selectedSlide}` && language !== "en") {
      fetchText(text);
    } else {
      setInputText(text);
    }
  }, [text]);

  const fetchText = async (texts) => {
    const t_text = await translateText(texts, language);
    setInputText(t_text);
  };
  const translateText = async (texts, targetLanguage) => {
    try {
      const response = await axios({
        method: "POST",
        url: `${domain}/duonut/language_translator`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          source: "en",
          target: targetLanguage,
          query: texts,
        },
      });

      if (response.status === 200) {
        // console.log("Translation:", response);
        return response?.data.translation; // return the translated text
      } else {
        // Handle unsuccessful status codes
        return "Error: Translation failed. Please try again.";
      }
    } catch (error) {
      console.error('Error in translation API:', error);
      return "Error translating text. Please try again."; // Handle API errors gracefully
    }
  };

  const fetchAudio = async (texts) => {
    const response = await fetch(`${domain}/duonut/get_speech`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ question_text: texts }),
    });

    const data = await response.json();
    if (data.audio_base64) {
      const audioSrc = `data:audio/mp3;base64,${data.audio_base64}`;
      setAudioUrl(audioSrc);
    }
  };

  const startListening = async () => {
    setError("");

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      recordedChunksRef.current = [];

      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;

      mediaRecorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          recordedChunksRef.current.push(event.data);
        }
      };

      mediaRecorder.start();
      console.log("Recording started!");

      // ---- SpeechRecognition part remains same ---- //
      const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      if (!SpeechRecognition) {
        setError("Speech recognition is not supported in your browser. Try Chrome or Edge.");
        return;
      }

      recognitionRef.current = new SpeechRecognition();
      recognitionRef.current.continuous = true;
      recognitionRef.current.interimResults = true;
      recognitionRef.current.lang = "en-US";

      recognitionRef.current.onresult = (event) => {
        let interimTranscript = "";
        let finalTranscript = "";

        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;
          if (event.results[i].isFinal) {
            finalTranscript += transcript + " ";
          } else {
            interimTranscript += transcript;
          }
        }

        console.log(finalTranscript || interimTranscript);
        setTextField(finalTranscript || interimTranscript);
      };

      recognitionRef.current.onerror = (event) => {
        console.error("Speech recognition error", event.error);
        setError(`Error: ${event.error}. Please try again.`);
        if (recognitionRef.current) {
          recognitionRef.current.stop();
          recognitionRef.current = null;
        }
        setIsListening(false);
      };

      recognitionRef.current.start();
      setIsListening(true);

    } catch (err) {
      console.error("Speech recognition error:", err);
      setError("Failed to start speech recognition. Please check your browser permissions.");
    }
  };

  const stopListening = () => {
    if (recognitionRef.current) {
      recognitionRef.current.stop()
      recognitionRef.current = null;
    }
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current.stream.getTracks().forEach(track => track.stop());
      mediaRecorderRef.current = null;
    }
    setIsListening(false);

    setTimeout(() => {
      if (recordedChunksRef.current.length === 0) {
        console.error("No audio recorded.");
        setError("No audio recorded. Please try speaking louder or allow microphone access.");
        return;
      }

      const audioBlob = new Blob(recordedChunksRef.current, { type: 'audio/webm' });
      const file = new File([audioBlob], "audio_recording.webm", { type: "audio/webm" });

      // console.log(file);
      audioFile = file;

      handleButtonClick(textField);
    }, 100);
  }


  const handleButtonClick = (num) => {
    setIsVisible(false);
    setTypedText("");

    if (location.pathname.includes("/duonut/") && !openEnded) {
      setClickedNum(num);

      var save_ans = {
        display_id: viewer_display_id,
        watch_id: save_ans_response[0] ? save_ans_response[0].watch_id : "",
        result: 0,
        question: text ? text : "",
        answered_text: num,
        // end: lastQue ? "1" : "0",
        nickname: viewer_nick_name,
        step: selectedSlide + 1,
        type: "Nps",
        // country: location[0] ? location[0].address?.country : "",
        // city: location[0] ? location[0].address?.state_district : "",
        // location: location[0] ? location[0].display_name : "",
        url_params: viewer_url_params,
      }
      // console.log(save_ans);
      const formData = new FormData();
      formData.append("analytic_file", audioFile);
      Object.keys(save_ans).forEach(key => {
        const value = typeof save_ans[key] === "object" ? JSON.stringify(save_ans[key]) : save_ans[key];
        formData.append(key, value);
      });

      dispatch(saveQuizAnsAsync(formData));

      var save_response = {
        type: "Nps",
        step: selectedSlide + 1,
        question: text ? text : "",
        answered_text: num,
      }
      dispatch(saveQuizResponse(save_response));

      var nextPage = selectedSlide + 1;
      duonutData?.user_activity[selectedSlide]?.condition?.map(node => {
        if (node.condition.length === 2) {
          if ((node.condition[0] === "equal to" && num === parseInt(node.condition[1])) ||
            (node.condition[0] === "not equal to" && num !== parseInt(node.condition[1])) ||
            (node.condition[0] === "lower than" && num < parseInt(node.condition[1])) ||
            (node.condition[0] === "greater than" && num > parseInt(node.condition[1])) ||
            (node.condition[0] === "lower or equal to" && num <= parseInt(node.condition[1])) ||
            (node.condition[0] === "greater or equal to" && num >= parseInt(node.condition[1]))) {
            nextPage = node.target - 1;
          }
        } else if (node.always) {
          nextPage = node.target - 1;
        }
      })

      setTimeout(() => {
        if (p_type === "1") {
          var act_len = duonutData.user_activity.length;
          // console.log(act_len);
          dispatch(updateGoToSlide(act_len));
          return null;
        }
        dispatch(updateGoToSlide(nextPage));
      }, 1000);
    }
    else if (location.pathname.includes("/duonut/") && openEnded) {
      setClickedNum(num);

      var userIsPro = false;
      if (duonutData?.created_by.pro_user) {
        userIsPro = true;
      } else if (duonutData?.created_by.expire_date) {
        const currentDate = new Date();
        const dateToCompare = new Date(duonutData?.created_by.expire_date);
        const comparisonResult = currentDate < dateToCompare;
        if (comparisonResult) {
          userIsPro = true;
        } else {
          userIsPro = false;
        }
      }
      if ((!userIsPro && aiCount < parseInt(duonutData?.setting?.open_ended_conversation_limit)) || (userIsPro && aiCount < parseInt(duonutData?.setting?.open_ended_conversation_limit))) {

        setloading(true);

        aiConversation = [...aiConversation,
        { question: inputText, answer: textField },
        ];

        var get_ans = {
          question: inputText,
          answer: num,
          objective: openEndedObjective,
          feedbackDesired: openEndedFeedbackDesired,
          aiConversation: aiConversation,
          option_type: 3,
        }

        dispatch(getOpenEndedQuestionAsync(get_ans)).then((res) => {
          // console.log(res);
          if (res?.question) {
            // console.log(res?.question);
            setInputText(res?.question);
            if (document.getElementById(`qainput-${selectedSlide + 1}-ai${aiCount}`)) {
              document.getElementById(`qainput-${selectedSlide + 1}-ai${aiCount}`).value = "";
            }
            setloading(false);

            var save_ans = {
              display_id: viewer_display_id,
              watch_id: save_ans_response[0] ? save_ans_response[0].watch_id : "",
              result: 1,
              question: inputText ? inputText : "",
              answered_text: num,
              // end: lastQue ? "1" : "0",
              nickname: viewer_nick_name,
              step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
              type: aiCount === 0 ? "Nps" : "QuestionAnswer",
              // country: location[0] ? location[0].address?.country : "",
              // city: location[0] ? location[0].address?.state_district : "",
              // location: location[0] ? location[0].display_name : "",
              url_params: viewer_url_params,
            }
            // console.log(save_ans);
            const formData = new FormData();
            formData.append("analytic_file", audioFile);
            Object.keys(save_ans).forEach(key => {
              const value = typeof save_ans[key] === "object" ? JSON.stringify(save_ans[key]) : save_ans[key];
              formData.append(key, value);
            });

            dispatch(saveQuizAnsAsync(formData));

            var save_response = {
              type: aiCount === 0 ? "Nps" : "QuestionAnswer",
              step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
              question: inputText ? inputText : "",
              answered_text: num,
            }
            dispatch(saveQuizResponse(save_response));

            aiCount++;
            // if (document.getElementById(`element-${id}-${slideId}`)) {
            //   console.log("hello",id,slideId, document.getElementById(`element-${id}-${slideId}`));
            //   document.getElementById(`element-${id}-${slideId}`).style.top = 120;
            //   document.getElementById(`element-${id}-${slideId}`).style.left = 200;
            //   document.getElementById(`element-${id}-${slideId}`).style.padding = 20;

            // }

          }
        }).catch((e) => {
          console.log(e.message, e);
        });

      }
      else {
        var save_ans = {
          display_id: viewer_display_id,
          watch_id: save_ans_response[0] ? save_ans_response[0].watch_id : "",
          result: 1,
          question: inputText ? inputText : "",
          answered_text: num,
          // end: lastQue ? "1" : "0",
          nickname: viewer_nick_name,
          step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
          type: aiCount === 0 ? "Nps" : "QuestionAnswer",
          // country: location[0] ? location[0].address?.country : "",
          // city: location[0] ? location[0].address?.state_district : "",
          // location: location[0] ? location[0].display_name : "",
          url_params: viewer_url_params,
        }
        // console.log(save_ans);
        const formData = new FormData();
        formData.append("analytic_file", audioFile);
        Object.keys(save_ans).forEach(key => {
          const value = typeof save_ans[key] === "object" ? JSON.stringify(save_ans[key]) : save_ans[key];
          formData.append(key, value);
        });

        dispatch(saveQuizAnsAsync(formData));

        var save_response = {
          type: aiCount === 0 ? "Nps" : "QuestionAnswer",
          step: aiCount === 0 ? selectedSlide + 1 : `${selectedSlide + 1}-ai${aiCount}`,
          question: inputText ? inputText : "",
          answered_text: num,
        }
        dispatch(saveQuizResponse(save_response));

        var nextPage = selectedSlide + 1;

        setTimeout(() => {
          dispatch(updateGoToSlide(nextPage));
        }, 1000);
      }
    }
  }
  // useEffect(() => {
  //   const element = document.getElementById(`element-${id}-${slideId}`);
  //   if (element && aiCount>0) {
  //     console.log("okay");
  //     element.style.top = "120px";
  //     element.style.left = "200px";
  //   }
  // }, [aiCount]);
  const handleQuestionAnswerInputChange = (e) => {
    // console.log(e)
    if (location.pathname.includes("/duonut/")) {
      if (e.keyCode === 13) {
        setTimeout(() => {
          var text_ans = e.target.value;
          handleButtonClick(text_ans);
        }, 0); // Let the event loop update React state first
      }
    }
  }
  return (
    <div ref={npsRef} >
      {(audioUrl || !duonutData?.setting?.question_speech || !queSpeechPlaying) ?
        <>
          {audioUrl && (
            <audio autoPlay style={{ display: "none" }}>
              <source src={audioUrl} type="audio/mp3" />
              Your browser does not support the audio element.
            </audio>
          )}
          {aiCount === 0 && <div style={{
            display: "flex",
            justifyContent: "center", alignItems: "center",
            flexDirection: 'column',
            gap: viewType === 3 || width < 800 ? "80px" : gap, color, fontFamily, fontSize, fontWeight, fontStyle, textDecoration, textTransform,
            textAlign, lineHeight, letterSpacing,
          }} >
            <div
              style={{
                width: "100%", paddingBottom: '8px', color: labelColor, fontSize: labelFontSize, fontWeight: labelFontWeight
              }}>{(duonutData?.setting?.question_speech && queSpeechPlaying && location.pathname.includes("/duonut/")) ? typedText : inputText}</div>

            <div>
              {isTypingDone && <>
                <div style={{
                  width: "100%",
                  display: "flex",
                  justifyContent:
                    textAlign === "center"
                      ? "center"
                      : textAlign === "right"
                        ? "flex-end"
                        : "flex-start", alignItems: "center",
                  flexWrap: "wrap"
                }}>
                  {Array.from({ length: maxLength + 1 }, (_, i) => {
                    return <div key={i} id={`option-id${i + 1}`}
                      style={{
                        display: "flex",
                        justifyContent: "center", alignItems: "center",
                        border: border ? border : "0", margin, padding, borderRadius,
                        width: `${size}px`, height: `${size}px`,
                        backgroundColor: isHovered < (i + 1) ? clickedNum < (i) ? backgroundColor : elementHoverAttr?.selectedBackgroundColor : elementHoverAttr?.backgroundColor
                      }}
                      onMouseEnter={() => setIsHovered(i + 1)}
                      onMouseLeave={() => setIsHovered(-1)}
                      onClick={() => handleButtonClick(i)}>
                      {i}
                    </div>
                  })}
                </div>
                <div style={{
                  display: "flex", justifyContent: 'space-between',
                  color: labelColor, fontSize: "13px", padding: "4px", opacity: "0.8"
                }}>
                  <div style={{ width: "8rem" }}>{negativeText}</div>
                  <div style={{ width: "8rem" }}>{positiveText}</div>
                </div>
              </>}
            </div>
          </div>}
          {openEnded && aiCount > 0 && <div style={{
            display: "flex", justifyContent: 'space-between', flexDirection: "column", height: width > 800 ? "200px" : "400px",
            width: width > 800 ? "450px" : "auto", margin: "auto"
          }}>
            <div
              style={{
                backgroundColor: "transparent",
                border: "0",
                outline: "none",
                // display: "flex",
                // alignItems: "center",
                width: "100%",
                color: labelColor, fontFamily, fontSize: "16px", fontWeight, fontStyle, textDecoration, textTransform,
                textAlign, lineHeight, letterSpacing
              }}
            > {(duonutData?.setting?.question_speech && queSpeechPlaying && location.pathname.includes("/duonut/")) ? typedText : inputText}</div>

            <div>
              {isVoiceInput && (location.pathname).includes("/duonut/") ? <><div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {!isListening ? (
                  <button
                    onClick={() => startListening()}
                    data-tooltip-content="Press to record your answer"
                    data-tooltip-id="record_audio_hover"
                    disabled={!isTypingDone} // 👈 disabled while typing
                    style={{ fontSize: "1.2rem", width: "60px", height: "60px", borderRadius: "10rem", cursor: "pointer", backgroundColor: "white", border: "1px solid #4299e1", color: "#4299e1" }}
                  >
                    <i className="fa fa-microphone"></i>
                  </button>
                ) : (
                  <button
                    onClick={() => stopListening()}
                    style={{ fontSize: "1.2rem", width: "60px", height: "60px", borderRadius: "10rem", cursor: "pointer", backgroundColor: "#4299e1", color: "white" }}
                  >
                    <i className="fa fa-microphone"></i>
                  </button>
                )}

                {!isListening && <button
                  data-tooltip-content="Answer using the keyboard"
                  data-tooltip-id="record_audio_hover"
                  disabled={!isTypingDone}
                  onClick={() => dispatch(updateIsVoiceInput(false))}
                  style={{ fontSize: "2rem", width: "4rem", height: "3.2rem", marginLeft: "1rem", borderRadius: "1rem", cursor: "pointer", backgroundColor: "white", color: "black" }}
                >
                  <i className="fa fa-keyboard-o"></i>
                </button>}
              </div>

                {isListening && (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <span style={{ fontSize: "12px", padding: "5px", backgroundColor: "#4299e1", color: "white", borderRadius: "6px", margin: "2px" }}>Recording...</span>
                  </div>
                )}

                {error && <div style={{ color: "red", display: "flex", justifyContent: "center" }}>{error}</div>}
              </>
                : <div style={{ display: "flex", alignItems: viewType === 3 || width < 800 ? "center" : "unset", flexDirection: viewType === 3 || width < 800 ? "column" : "unset" }}>
                  <input type='text' key={`qainput-${selectedSlide + 1}-ai${aiCount}`}
                    id={`qainput-${selectedSlide + 1}-ai${aiCount}`}
                    style={{
                      width: "100%", minHeight: "40px",
                      color: labelColor, fontFamily, fontSize: fontSize, fontStyle, textDecoration, textTransform,
                      textAlign: "left", lineHeight, letterSpacing, padding: "4px 10px", boxSizing: "border-box",
                      backgroundColor: "transparent", border: '1px solid gray', margin: "0px 5px", borderRadius
                    }}
                    disabled={!isTypingDone} // 👈 disabled while typing
                    onChange={(e) => setTextField(e.target.value)}
                    onKeyUp={(e) => handleQuestionAnswerInputChange(e)}
                    readOnly={location.pathname.includes("/duonut/") ? false : true}
                    required={required}
                    placeholder={"Type your answer here.."}
                  />
                  {textField ? <button id="AiSubmitBtn" onClick={() => handleButtonClick(textField)}
                    style={{
                      backgroundColor: "#4299e1", color: "white", borderRadius: "6px", padding: '1rem',
                      cursor: "pointer", margin: viewType === 3 || width < 800 ? "1rem 0px" : "0px"
                    }}>
                    {loading ? <img alt="loader" src={require(`../../assets/Images/loader.gif`)} style={{ margin: "auto", height: "1rem" }} />
                      : viewType === 3 || width < 800 ? <span style={{ fontSize: "1rem" }}> Next</span> : <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 448 512" aria-hidden="true" focusable="false" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"></path>
                      </svg>}
                  </button> : <button
                    data-tooltip-content="Answer using the microphone"
                    data-tooltip-id="record_audio_hover"
                    disabled={!isTypingDone}
                    onClick={() => dispatch(updateIsVoiceInput(true))}
                    style={{ width: "55px", height: "50px", borderRadius: "10rem", cursor: "pointer", backgroundColor: "#4299e1", color: "white" }}
                  >
                    <i className="fa fa-microphone"></i>
                  </button>}
                </div>
              }
            </div>
          </div>}
          <ReactTooltip id="record_audio_hover" place="top" effect="solid" interactive={true}
            style={{ fontSize: "12px" }}> </ReactTooltip>
        </> : <div style={{ display: "flex", justifyContent: "center" }}><img alt="loader" src={require(`../../assets/Images/dot_loading.gif`)} /></div>}
    </div>
  );
}

export default Nps;
